module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "PurchaseDashboardDetailpdf",
    attrs: {
      "id": "PurchaseDashboardDetailpdf"
    }
  }, [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "4"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    staticClass: "ml-2 mr-2",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n            ")], 1)], 1), _vm._v(" "), _c('h5', {
    staticClass: "mt-1 mr-2"
  }, [_vm._v("\n            " + _vm._s(_vm.$route.name || "Purchase Dashboard - Detail View") + "\n          ")])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('h5', [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalData) + " Entries")]) : _vm._e()])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    class: ' ml-4' + _vm.visible ? null : 'collapsed',
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": _vm.Filter.DateTypeFilter ||
        _vm.Filter.ModuleTypeFilter ||
        _vm.Filter.PaymentTypeFilter ||
        _vm.Filter.JobNoFilter ||
        _vm.Filter.TransactionNoFilter ||
        _vm.Filter.clientFilter ||
        _vm.Filter.slineFilter ||
        _vm.Filter.TransportTypeFilter ||
        _vm.Filter.ShipemntTypeFilter ||
        _vm.Filter.PORFilter ||
        _vm.Filter.POLFilter ||
        _vm.Filter.PODFilter ||
        _vm.Filter.FPODFilter ||
        _vm.Filter.statusFilter ||
        _vm.Filter.commonFilter ||
        _vm.Filter.createdByFilter ||
        _vm.Filter.branchFilter ||
        _vm.Filter.dateRange.startDate ||
        _vm.Filter.dateRange.endDate ?
        'outline-danger' :
        'outline-primary',
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v(_vm._s(_vm.Filter.DateTypeFilter ||
    _vm.Filter.ModuleTypeFilter ||
    _vm.Filter.PaymentTypeFilter ||
    _vm.Filter.JobNoFilter ||
    _vm.Filter.TransactionNoFilter ||
    _vm.Filter.clientFilter ||
    _vm.Filter.slineFilter ||
    _vm.Filter.TransportTypeFilter ||
    _vm.Filter.ShipemntTypeFilter ||
    _vm.Filter.PORFilter ||
    _vm.Filter.POLFilter ||
    _vm.Filter.PODFilter ||
    _vm.Filter.FPODFilter ||
    _vm.Filter.statusFilter ||
    _vm.Filter.commonFilter ||
    _vm.Filter.createdByFilter ||
    _vm.Filter.branchFilter ||
    _vm.Filter.dateRange.startDate ||
    _vm.Filter.dateRange.endDate ?
    "Filter ON" :
    "Filter OFF"))]), _vm._v(" "), (_vm.paymentList.length > 0) ? _c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('getPaymentList', 'Export As Excel')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.ExcelBtnName) + "\n            "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.paymentList.length > 0) ? _c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.exportToExcelClient
    }
  }, [_vm._v("\n            Export (Client XLSX)\n          ")]) : _vm._e(), _vm._v(" "), (_vm.paymentList.length > 0) ? _c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "sm",
      "variant": "info"
    },
    on: {
      "click": _vm.generatePaymentPDF
    }
  }, [_c('i', {
    staticClass: "fa fa-cloud-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" PDF\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)])], 1), _vm._v(" "), (_vm.visible) ? _c('div', [_c('b-card', [_c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.dateTypeList,
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select Date Type"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.DateTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "DateTypeFilter", $$v)
      },
      expression: "Filter.DateTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale,
      "disabled": _vm.Filter.DFlag ? true : false
    },
    on: {
      "update": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "dateRange", $$v)
      },
      expression: "Filter.dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Module Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.moduleOptions,
      "option-value": "Val",
      "option-text": "Text",
      "placeholder": "Select Module Type"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.ModuleTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "ModuleTypeFilter", $$v)
      },
      expression: "Filter.ModuleTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Payment Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.payTypeOptions,
      "option-value": "Val",
      "option-text": "Text",
      "placeholder": "Select Payment Type"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.PaymentTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "PaymentTypeFilter", $$v)
      },
      expression: "Filter.PaymentTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Job NO Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Job NO Filter",
      "id": "JobNoFilter",
      "name": "JobNoFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.JobNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "JobNoFilter", $$v)
      },
      expression: "Filter.JobNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Transaction No Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Transaction No Filter",
      "id": "TransactionNoFilter",
      "name": "TransactionNoFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.TransactionNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "TransactionNoFilter", $$v)
      },
      expression: "Filter.TransactionNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Transport Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.transportTypeList,
      "option-value": "value",
      "option-text": "value",
      "placeholder": "Select Transport Type"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.TransportTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "TransportTypeFilter", $$v)
      },
      expression: "Filter.TransportTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Shipment Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.shipmentTypeList,
      "option-value": "value",
      "option-text": "value",
      "placeholder": "Select Shipment Type"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.ShipemntTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "ShipemntTypeFilter", $$v)
      },
      expression: "Filter.ShipemntTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Shipping Line")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllShippingLineList'],
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.slineFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "slineFilter", $$v)
      },
      expression: "Filter.slineFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Client")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "id": "clientFilter",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client Name"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.clientFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "clientFilter", $$v)
      },
      expression: "Filter.clientFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Branch")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllBranchList'],
      "id": "branchfilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.branchFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "branchFilter", $$v)
      },
      expression: "Filter.branchFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POR")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllPORList'],
      "id": "PORFilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.PORFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "PORFilter", $$v)
      },
      expression: "Filter.PORFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POL")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllPOLList'],
      "id": "POLFilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.POLFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "POLFilter", $$v)
      },
      expression: "Filter.POLFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POD")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllPODList'],
      "id": "PODFilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.PODFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "PODFilter", $$v)
      },
      expression: "Filter.PODFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("FPOD")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllLocationDetailsFinalList'],
      "id": "FPODFilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.FPODFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "FPODFilter", $$v)
      },
      expression: "Filter.FPODFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Common Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Common Filter",
      "id": "commonFilter",
      "name": "commonFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.commonFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "commonFilter", $$v)
      },
      expression: "Filter.commonFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.statusList,
      "option-value": "text",
      "option-text": "value",
      "placeholder": "Select Status"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.statusFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "statusFilter", $$v)
      },
      expression: "Filter.statusFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v(" Created User ")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "createdByFilter",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Created User"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.createdByFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "createdByFilter", $$v)
      },
      expression: "Filter.createdByFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "ml-1 pull-right",
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive tableMain gutr"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "items": _vm.paymentList,
      "fields": _vm.PaymentFields,
      "primary-key": "id_email_section",
      "per-page": _vm.pagination.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v("\n                  " + _vm._s(row0.index + 1 + (_vm.pagination.currentPage - 1) * _vm.pagination.perPage) + "\n                ")])]
      }
    }, {
      key: "TransactionNo",
      fn: function(row1) {
        return [_c('div', [_c('strong', [_vm._v("Trans No:")]), _vm._v(" " + _vm._s(row1.item.TransactionNo || "")), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Request Date:")]), _vm._v(" " + _vm._s(row1.item.CreatedAt || "")), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Request By:")]), _vm._v(" " + _vm._s(row1.item.RequestedBy || "")), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Status:")]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": row1.item.IsPaymentDone == 1 ? 'success' : 'warning'
          }
        }, [_vm._v("\n                    " + _vm._s(row1.item.IsPaymentDone == 1 ? 'Paid' : 'Pending') + "\n                  ")]), _vm._v(" "), _c('strong', [_vm._v("Approval Status:")]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": row1.item.approval_status == 'APPROVED' ? 'success' : 'warning'
          }
        }, [_vm._v("\n                    " + _vm._s(row1.item.approval_status) + "\n                  ")])], 1)]
      }
    }, {
      key: "JobNo",
      fn: function(row1) {
        return [_c('div', [_c('strong', [_vm._v("Job No:")]), _vm._v(" " + _vm._s(row1.item.JobNo || "")), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Job Date:")]), _vm._v(" " + _vm._s(row1.item.JobDate || "")), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Job Raised By:")]), _vm._v(" " + _vm._s(row1.item.JobRaisedBy || "")), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Branch:")]), _vm._v(" " + _vm._s(row1.item.Branch || "")), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Job Type:")]), _vm._v(" " + _vm._s(row1.item.MJobType || "") + "\n                ")])]
      }
    }, {
      key: "ClientName",
      fn: function(row1) {
        return [_c('div', [_c('strong', [_vm._v("Sline Name:")]), _vm._v(" " + _vm._s(row1.item.SlineName || "")), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Client:")]), _vm._v(" " + _vm._s(row1.item.ClientName || "") + "\n                ")])]
      }
    }, {
      key: "Location",
      fn: function(row1) {
        return [_c('div', [_c('strong', [_vm._v("POR:")]), _vm._v(" " + _vm._s(row1.item.POR || "")), _c('br'), _vm._v(" "), _c('strong', [_vm._v("POL:")]), _vm._v(" " + _vm._s(row1.item.POL || "")), _c('br'), _vm._v(" "), _c('strong', [_vm._v("POD:")]), _vm._v(" " + _vm._s(row1.item.POD || "")), _c('br'), _vm._v(" "), _c('strong', [_vm._v("FPOD:")]), _vm._v(" " + _vm._s(row1.item.FPOD || "") + "\n                ")])]
      }
    }, {
      key: "PaymentDetails",
      fn: function(row1) {
        return [_c('div', [_c('strong', [_vm._v("Payment Type:")]), _vm._v(" " + _vm._s(_vm.getPaymentTypeText(row1.item.PaymentType))), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Module Type:")]), _vm._v(" " + _vm._s(_vm.getModuleTypeText(row1.item.ModuleType))), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Transport Type:")]), _vm._v(" " + _vm._s(row1.item.JobTransportType || "")), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Container Type:")]), _vm._v(" " + _vm._s(row1.item.JobTContainerType || "") + "\n                ")])]
      }
    }, {
      key: "Amount",
      fn: function(row1) {
        return [_c('div', [(row1.item.payment_type == 'Additional Task') ? _c('strong', [_vm._v("Bill to SHIPPER: " + _vm._s((row1.item.sc_category))), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.payment_type == 'Additional Task') ? _c('strong', [_vm._v("Selling Amount: " + _vm._s((row1.item.selling_amt))), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.payment_type == 'Additional Task') ? _c('strong', [_vm._v("Remark: " + _vm._s((row1.item.sc_remark))), _c('br')]) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v("Inv Date:")]), _vm._v(" " + _vm._s((row1.item.inv_date))), _c('br'), _vm._v(" "), (row1.item.payment_type == 'Additional Task') ? _c('strong', [_vm._v("Inv Amount: " + _vm._s(_vm.formatAmount(row1.item.inv_amt || row1.item.totalPayAmt || row1.item.TotalPayAmt || 0))), _c('br')]) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v("Pay Amount:")]), _vm._v(" " + _vm._s(_vm.formatAmount(row1.item.inv_pay_amt || row1.item.totalPayAmt || row1.item.TotalPayAmt || 0))), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Currency:")]), _vm._v(" " + _vm._s(row1.item.currency || "")), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Pay Mode:")]), _vm._v(" " + _vm._s(row1.item.inv_pay_mode || "")), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Pay Ref No:")]), _vm._v(" " + _vm._s(row1.item.inv_pay_ref_no || "")), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Pay Date:")]), _vm._v(" " + _vm._s(row1.item.inv_pay_date || "") + "\n                  "), (row1.item.inv_doc_url && row1.item.payment_type != 'Additional Task') ? _c('div', [_c('b-button', {
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "xs",
            "variant": "warning",
            "href": String(row1.item.inv_doc_url).startsWith('http') ? row1.item.inv_doc_url : ("" + _vm.docURL + (row1.item.inv_doc_url)),
            "target": "_blank",
            "rel": "noopener"
          }
        }, [_vm._v("\n                      View Doc\n                    ")])], 1) : _vm._e()])]
      }
    }, {
      key: "AdditionalInfo",
      fn: function(row1) {
        return [_c('div', [_c('strong', [_vm._v("Invoice Type:")]), _vm._v(" " + _vm._s(row1.item.invoiceType || "")), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Invoice Category:")]), _vm._v(" " + _vm._s(row1.item.invoiceCategory || "")), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Due Date:")]), _vm._v(" " + _vm._s(row1.item.dueDate || "")), _c('br'), _vm._v(" "), _c('strong', [_vm._v("SOB Date:")]), _vm._v(" " + _vm._s(row1.item.sobDate || "")), _c('br'), _vm._v(" "), _c('strong', [_vm._v("HBL:")]), _vm._v(" " + _vm._s(row1.item.HBL || "")), _c('br'), _vm._v(" "), _c('strong', [_vm._v("MBL:")]), _vm._v(" " + _vm._s(row1.item.MBL || "") + "\n                ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)])])], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-113a29c2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/purchaseDashboardDetail.vue
// module id = 2401
// module chunks = 0